import { ADD_LOAD_COUNTER, CLEAR_LOAD_COUNTER, SUB_LOAD_COUNTER } from '../action-types';

export const addLoaderCounter = ({ message, background, scope }) => ({ type: ADD_LOAD_COUNTER, message, background, scope });

export const subLoaderCounter = ({ message, background, scope }) => ({ type: SUB_LOAD_COUNTER, message, background, scope });

export const clearLoaderCounter = ({ scope }) => ({ type: CLEAR_LOAD_COUNTER, scope });
